import { Component } from '@angular/core';
import { SpinnerService } from './core/services/spinner/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  
    constructor(
      public spinnerService: SpinnerService
    ) {

    }

}
